import { personName, themeCommand } from "@nexxt/app-kit";
import { Button, DropdownMenu } from "@nexxt/ui";
import { useNavigate } from "@tanstack/react-router";
import { CircleUser, Ellipsis, LogOut, Moon, ShieldCheck, UserRound } from "lucide-react";
import { accountPaths } from "./access/sign-in";
import { signOut, useMe } from "./me";
import { m } from "./paraglide/messages.js";

// Who is signed in, and a menu with the theme, the profile, the security of the account and the way out. In the sidebar the name
// stays in view next to the menu; in the top bar (`compact`) the icon of the user opens the menu, which names it.

export function UserMenu({ compact = false }: { compact?: boolean }) {
  const theme = themeCommand();
  const navigate = useNavigate();
  // a session that owes a second factor reaches only the security page (ADR-151)
  const owesFactor = useMe().mfaEnrollmentRequired;
  const menu = (
    <DropdownMenu
      trigger={
        <Button variant="ghost" size="icon" aria-label={m.user_menu()} className="text-muted-foreground">
          {compact ? <CircleUser aria-hidden /> : <Ellipsis aria-hidden />}
        </Button>
      }
      {...(compact && { header: <UserSummary /> })}
      items={[
        { id: "theme", label: theme.label, icon: <Moon aria-hidden />, onSelect: theme.run },
        ...(owesFactor
          ? []
          : [
              {
                id: "account",
                label: m.nav_account(),
                icon: <UserRound aria-hidden />,
                onSelect: () => void navigate({ to: accountPaths.account }),
              },
            ]),
        {
          id: "security",
          label: m.nav_security(),
          icon: <ShieldCheck aria-hidden />,
          onSelect: () => void navigate({ to: accountPaths.security }),
        },
        { id: "sign-out", label: m.sign_out(), icon: <LogOut aria-hidden />, onSelect: () => void signOut() },
      ]}
    />
  );
  if (compact) return menu;
  return (
    <div className="flex items-center gap-2 pl-2">
      <div className="min-w-0 flex-1">
        <UserSummary />
      </div>
      {menu}
    </div>
  );
}

function UserSummary() {
  const me = useMe();
  return (
    <div className="min-w-0 text-xs">
      <p className="truncate font-medium">{personName(me)}</p>
      <p className="truncate text-muted-foreground">{me.email}</p>
    </div>
  );
}
